/**
 * Purely decorative: the thing the frosted glass in every other section
 * blurs. Driven entirely by CSS custom properties / animations from
 * index.css — no component-level JS state, so `prefers-reduced-motion`
 * (index.css's global rule) suppresses all of it for free.
 */
export function Backdrop() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '-16vh',
          left: '-10vw',
          width: '56vw',
          height: '56vw',
          borderRadius: '50%',
          background: 'radial-gradient(circle, var(--trailA) 0%, transparent 68%)',
          opacity: 'var(--orbA)',
          filter: 'blur(38px)',
          animation: 'cDriftA 26s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-22vh',
          right: '-14vw',
          width: '62vw',
          height: '62vw',
          borderRadius: '50%',
          background: 'radial-gradient(circle, var(--trailB) 0%, transparent 68%)',
          opacity: 'var(--orbB)',
          filter: 'blur(44px)',
          animation: 'cDriftB 32s ease-in-out infinite',
        }}
      />
      <svg
        aria-hidden="true"
        viewBox="0 0 1200 800"
        preserveAspectRatio="none"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          opacity: 'var(--trailOp)',
        }}
      >
        {/* TRAILS.md §6.1/§6.3: JSX camelCase SVG props like `strokeDasharray`
            get set by Preact as a literal (invalid) `strokeDasharray` DOM
            attribute, not the real kebab-case `stroke-dasharray` — the browser
            never recognizes it, so no dash pattern (and no visible stroke
            colour) was ever actually applied. Every presentation property
            that matters for rendering goes in `style` instead, where the
            camelCase JS property names (style.strokeDasharray etc.) map
            correctly to their real CSS properties. */}
        <path
          d="M-100 620 Q220 320 560 480 T1300 300"
          style={{
            fill: 'none',
            stroke: 'var(--trailA)',
            strokeWidth: 2.2,
            strokeLinecap: 'round',
            strokeDasharray: '10 22',
            animation: 'cTrail1 30s linear infinite',
          }}
        />
        <path
          d="M-100 700 Q260 420 600 560 T1300 400"
          style={{
            fill: 'none',
            stroke: 'var(--trailB)',
            strokeWidth: 2.6,
            strokeLinecap: 'round',
            strokeDasharray: '14 26',
            animation: 'cTrail2 24s linear infinite',
          }}
        />
        <path
          d="M-100 500 Q300 240 640 360 T1300 180"
          style={{
            fill: 'none',
            stroke: 'var(--trailB)',
            strokeWidth: 1.4,
            strokeLinecap: 'round',
            strokeDasharray: '6 30',
            animation: 'cTrail3 40s linear infinite',
          }}
        />
      </svg>
    </div>
  );
}
